if (!customElements.get('afr-account-modal')) {
  customElements.define('afr-account-modal', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      if (!this.dialog || !this.form || typeof this.dialog.showModal !== 'function') return;
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const close = () => this.dialog.close();
      document.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        const trigger = target?.closest('.header-account-menu shopify-account,.mobile-header-account-menu shopify-account,.afr-signin-label,.afr-cart-account-link,[data-afr-account-open]');
        if (!trigger || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.returnFocus = event.composedPath().find(node => node instanceof HTMLElement && node.matches('a,button,[tabindex]')) || trigger;
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('afr-account-modal-open');
        this.querySelector('input')?.focus({ preventScroll: true });
      }, { capture: true, signal });
      this.querySelector('[data-afr-account-close]').addEventListener('click', close, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('afr-account-modal-open');
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }, { signal });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.form.reportValidity()) return;
        const email = this.form.elements.namedItem('login_hint').value.trim();
        const url = new URL(this.dataset.loginUrl, this.dataset.storeUrl || window.location.origin);
        url.searchParams.set('login_hint', email);
        url.searchParams.set('login_hint_mode', 'submit');
        url.searchParams.delete('display');
        if (this.dataset.designMode === 'true') {
          window.open(url.href, '_blank', 'noopener,noreferrer');
          return;
        }
        close();
        window.location.assign(url.href);
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('afr-account-modal-open');
    }
  });
}